// src/main.js
import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import { createPinia } from "pinia";
import piniaPluginPersistedState from "pinia-plugin-persistedstate";
import "bootstrap/dist/css/bootstrap.min.css"; // Import Bootstrap CSS
import "bootstrap-icons/font/bootstrap-icons.css";

import * as Sentry from "@sentry/vue";

import { useThemeStore } from "@/stores/theme";
import { useSessionStore } from "@/stores/session";
import { scheduleRefresh, setForceLogout } from "@/services/api_client";

// Inject Device-ID Generation
// Device-ID generation was originally handled here, but that approach fails
// when this tab is freshly opened, since module imports are evaluated before main.js runs.
// To ensure the device_id is always initialized before any API requests are made,
// the logic has been moved to api_client.js, where it's guaranteed to run on first use.
// let deviceId = sessionStorage.getItem('device_id')
// if (!deviceId) {
//   deviceId = crypto.randomUUID()
//   sessionStorage.setItem('device_id', deviceId)
// }
//

const app = createApp(App);
const pinia = createPinia();

Sentry.init({
  app,
  dsn: "https://9db1f2e27660571dbb1660ed6ad5f1e8@o59337.ingest.us.sentry.io/4508264232189952",
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
  environment: process.env.VUE_APP_ENV,
  release: process.env.VUE_APP_VERSION,
});

pinia.use(piniaPluginPersistedState);

app.use(pinia);
app.use(router);
console.log(`[boot] installing done`);

app.mount("#app");
console.log(`[boot] app mounted`);

// Initialize theme from hostname once
const themeStore = useThemeStore();
themeStore.initFromHostname();
themeStore.applyCssVarsToRoot();
console.log(`[boot] theme applied`);

// If an authenticated session exists with a group, override theme
const session = useSessionStore();
if (session.isAuthenticated && session.groupName) {
  themeStore.setThemeByGroup(session.groupName);
  themeStore.applyCssVarsToRoot();
  console.log(`[boot] group theme applied`);
}

// Provide a safe logout that can now use store + router
setForceLogout(() => {
  try {
    const s = useSessionStore(pinia);
    s.logout();
  } finally {
    router.push({ path: "/login", query: { error: "session-expired" } });
  }
});

// Arm refresh only after mount (prevents first-load breakage)
if (
  sessionStorage.getItem("authToken") &&
  sessionStorage.getItem("refreshToken")
) {
  scheduleRefresh();
}
